<template>
  <a :href="activityLink" target="_blank" class="row m-n block">
    <div class="col-md-4 no-padder">
      <div class="img-block">
        <div class="img-container" v-bind:style="imageStyle"></div>
      </div>
    </div>

    <div class="col-md-8">
      <span v-if="object.comment" class="clear">
        <span class="block m-b-sm">{{ object.comment }}</span>
      </span>
      <span v-else-if="activity.object" class="clear">
        <span class="block m-b-sm commented-title">{{ activity.object.title }}</span>
        <small class="block commented-description">{{ activity.object.description }}</small>
      </span>
      <div v-else class="clear">
        <span class="block m-b-sm commented-title">{{ activity.content.title }}</span>
        <small class="block commented-description">{{ activity.content.description }}</small>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: ['activity'],
  data() {
    return {
      activityLink: '',
      slug: '',
    }
  },
  mounted() {
    this.defineLink()
    // this.slug = this.object.slug ? this.object.slug : this.object.alias;
    // this.activityLink = `${window.user.community_url}/${window.user.community_domain}/default/events/view/${this.slug}`
  },
  computed: {
    object() {
      return this.activity.object ? this.activity.object : this.activity.content
    },
    imageStyle() {
      const fallbackImage01 =
        this.activity.object && this.activity.object.thumbs
          ? this.activity.object.thumbs['thumb']
          : undefined
      const fallbackImage02 =
        this.activity.object && this.activity.object.thumbs
          ? this.activity.object.thumbs['thumb-lg']
          : undefined
      const fallbackImage03 =
        this.activity.content && this.activity.content.thumbs
          ? this.activity.content.thumbs['thumb-lg']
          : undefined
      const fallbackImage04 = '/vue-app/assets/img/article.svg'

      return {
        'background-image':
          'url(' +
          fallbackImage01 +
          '), ' +
          'url(' +
          fallbackImage02 +
          '), ' +
          'url(' +
          fallbackImage03 +
          '), ' +
          'url(' +
          fallbackImage04 +
          ')',
      }
    },
  },
  methods: {
    defineLink() {
      const baseLink = `${window.user.community_url}/${window.user.community_domain}/default/`
      const slug = this.object.slug ? this.object.slug : this.object.alias

      if (this.activity.object) {
        switch (this.activity.action_name) {
          case 'post_create':
          case 'post_update':
          case 'post_like':
          case 'post_comment':
          case 'post_comment_like':
            this.activityLink = baseLink + `post/view/${slug}`
            break
          case 'media':
            this.activityLink =
              baseLink + `corporate#/view/${this.activity.owner.id}/media`
            break
          case 'event_create':
          case 'event_join':
          case 'event_update':
          case 'event_like':
          case 'event_comment':
          case 'event_comment_like':
            this.activityLink = baseLink + `events/view/${slug}`
            break
          case 'wall':
            this.activityLink =
              this.object.type == 'article' ? this.object.url : '#'
            break
          default:
            this.activityLink = '#'
            break
        }
      } else {
        switch (this.activity.content_type) {
          case 'post':
            this.activityLink = baseLink + `post/view/${slug}`
            break
          case 'event':
            this.activityLink = baseLink + `events/view/${slug}`
            break
          case 'groups':
            this.activityLink = baseLink + `groups/view/${slug}`
            break
          case 'blog':
            this.activityLink = baseLink + `blog/view/${slug}`
            break
          case 'profile':
            this.activityLink = baseLink + `profiles/view/${slug}`
            break
          default:
            this.activityLink = '#'
            break
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.img-block {
  height: 153px;
  width: 100%;
  float: right;
  padding: 0;
  margin: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.img-block .img-container {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
@media only screen and (min-width: 1200px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 1024px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 1023px) and (min-width: 768px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 767px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>


